module.exports = __webpack_public_path__ + "img/not-icon.254396b6.svg";